import { createContext, useContext, useState } from "react";
import { loggedInUserDetails, saveLastUrl } from "../utils/helper";

const AuthContext = createContext();

const getPermissionsFromToken = () => {
  try {
    const payload = loggedInUserDetails();
    return payload.permissions || [];
  } catch {
    return [];
  }
};

export const AuthProvider = ({ children }) => {
  const [permissions, setPermissions] = useState(getPermissionsFromToken);

  const login = (navigate) => {
    try {
      // set permission into state 
      const loginUser = loggedInUserDetails();
      setPermissions(loginUser.permissions || []);

      // remamber last page details
      const lastPage = localStorage.getItem(`${loginUser?.sub}_lastUrl`);
      if (lastPage) {
        localStorage.removeItem("lastUrl");
        navigate(lastPage);
      } else {
        navigate("/dashboard");
      }
    } catch {
      setPermissions([]);
    }
  };

  const logout = () => {
    // last page details
    saveLastUrl();

    // remove 
    localStorage.removeItem("token");
    localStorage.removeItem("language");
    setPermissions([]);
    localStorage.clear();

    window.location.href = "/";
  };

  const hasPermission = (code) => {
    return permissions.includes(code) || permissions.includes("fullAccess");
  };

  return (
    <AuthContext.Provider
      value={{
        permissions,
        login,
        logout,
        hasPermission
      }}
    >
      {children}
    </AuthContext.Provider>
  );

};

export const useAuth = () => useContext(AuthContext);